import { stripHTML } from 'utils/helper';

import { CONTEXT_LIMITS } from './constants';

export const pruneEmptyContext = (value) => {
    if (Array.isArray(value)) {
        return value.map(pruneEmptyContext).filter((item) => {
            if (item == null) return false;
            if (Array.isArray(item)) return item.length > 0;
            if (typeof item === 'object') return Object.keys(item).length > 0;
            return true;
        });
    }

    if (!value || typeof value !== 'object') return value;

    return Object.entries(value).reduce((result, [key, entry]) => {
        const prunedEntry = pruneEmptyContext(entry);
        const isEmptyArray = Array.isArray(prunedEntry) && prunedEntry.length === 0;
        const isEmptyObject =
            prunedEntry &&
            typeof prunedEntry === 'object' &&
            !Array.isArray(prunedEntry) &&
            Object.keys(prunedEntry).length === 0;

        if (
            prunedEntry === undefined ||
            prunedEntry === null ||
            prunedEntry === '' ||
            isEmptyArray ||
            isEmptyObject
        ) {
            return result;
        }

        return {
            ...result,
            [key]: prunedEntry,
        };
    }, {});
};

export const cleanContextText = (value, maxLength = CONTEXT_LIMITS.MAX_TEXT_CHARS) => {
    const text = stripHTML(value || '')
        .replace(/\s+/g, ' ')
        .trim();

    if (!text) return undefined;
    if (text.length <= maxLength) return text;
    return `${text.slice(0, maxLength).trim()}...`;
};

export const toNumberOrNull = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : null;
};
